import { createContext, useContext } from "react"
import Coord from "../logic/math/Coord";

const transformContext = createContext({
	panOffset: Coord.Zero,
	zoomLevel: 1
});

export const TransformProvider = transformContext.Provider;
export const useTransformContext = () => useContext(transformContext);